import { GROUP_CART_ADD_ITEMS, GROUP_CART_ADD_ITEMS_FAIL, GROUP_CART_ADD_ITEMS_SUCCESS, GROUP_CART_CREATE, GROUP_CART_CREATE_FAIL, GROUP_CART_CREATE_SUCCESS, GROUP_CART_LIST, GROUP_CART_LIST_FAIL, GROUP_CART_LIST_SUCCESS, GROUP_CART_SINGLE, GROUP_CART_SINGLE_FAIL, GROUP_CART_SINGLE_SUCCESS, INVITE_MEMBER, INVITE_MEMBER_FAIL, INVITE_MEMBER_SUCCESS, UNASSIGNED_ITEMS, UNASSIGNED_ITEMS_FAIL, UNASSIGNED_ITEMS_SUCCESS } from "../actions/group-cart-actions";

const initialState = {
    isLoading: false,
    /** True after first GROUP_CART_LIST success or fail — avoids empty UI before the first fetch runs. */
    hasFetchedGroupCartList: false,
    isMeLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    groupCart: [],
    singleCart: {},
    unassignedItemsList: []
};
const groupCartReducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case GROUP_CART_LIST: {
            return {
                ...state,
                isMeLoading: true,
                isLoading: true,
            };
        }
        case GROUP_CART_LIST_SUCCESS: {
            return {
                ...state,
                groupCart: payload.data,
                isMeLoading: false,
                isLoading: false,
                hasFetchedGroupCartList: true,
            };
        }
        case GROUP_CART_LIST_FAIL: {
            return {
                ...state,
                isMeLoading: false,
                isLoading: false,
                hasFetchedGroupCartList: true,
            };
        }
        case UNASSIGNED_ITEMS: {
            return {
                ...state,
                isMeLoading: true,
            };
        }
        case UNASSIGNED_ITEMS_SUCCESS: {

            return {
                ...state,
                unassignedItemsList: payload.data,
                isMeLoading: false,
            };
        }
        case UNASSIGNED_ITEMS_FAIL: {
            return {
                ...state,
                isMeLoading: false,
            };
        }
        case GROUP_CART_SINGLE: {
            return {
                ...state,
                isLoading: true,
                isMeLoading: true,
            };
        }
        case GROUP_CART_SINGLE_SUCCESS: {
            return {
                ...state,
                singleCart: payload.data,
                isLoading: false,
                isMeLoading: false,
            };
        }

        case GROUP_CART_SINGLE_FAIL: {
            return {
                ...state,
                isLoading: false,
                isMeLoading: false,
            };
        }
        case GROUP_CART_CREATE: {
            return {
                ...state,
                isMeLoading: true,
            };
        }

        case GROUP_CART_CREATE_SUCCESS: {
            return {
                ...state,
                isMeLoading: false,
            };
        }

        case GROUP_CART_CREATE_FAIL: {
            return {
                ...state,
                isMeLoading: false,
            };
        }
        case INVITE_MEMBER: {
            return {
                ...state,
                isMeLoading: true,
            };
        }

        case INVITE_MEMBER_SUCCESS: {
            return {
                ...state,
                isMeLoading: false,
            };
        }

        case INVITE_MEMBER_FAIL: {
            return {
                ...state,
                isMeLoading: false,
            };
        }
        case GROUP_CART_ADD_ITEMS: {
            return {
                ...state,
                isMeLoading: true,
            };
        }

        case GROUP_CART_ADD_ITEMS_SUCCESS: {
            return {
                ...state,
                isMeLoading: false,
            };
        }

        case GROUP_CART_ADD_ITEMS_FAIL: {
            return {
                ...state,
                isMeLoading: false,
            };
        }

        default: {
            return { ...state };
        }
    }
};
export default groupCartReducer;
